import FBSyncBase from "./framework/FBSyncBase";
import {SimRunes} from "./calculation/CalculationObjects";
import {SimSkillOrder} from "./calculation/SkillOrder";
import Player from "./Player";


export default class Simulation extends FBSyncBase {
    mePlayer:Player;
    themPlayer:Player;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/Simulation.ts